import React, { useRef, useEffect, useState } from 'react'
import { Button, Toast } from '@ow/comps'
import {
  useAppEx,
  useFetchRemoteData,
  useBatchProcessStore,
  useTbViewStore,
  useDetailStore,
} from '@vt/hooks'
import { WebBasicForm } from '@ow/ditto'
import { upload } from '@vt/apis/lib-ex/v2/givrali'
import { fetchUcaseExtBackFill } from '@vt/apis/lib-ex/v2/tables'
import { get, pick } from 'lodash-es'
import styled from '@emotion/styled'

const StyledButtons = styled.div`
  display: flex;
  justify-content: end;
  button + button {
    margin-left: 15px;
  }
`
const StyledFormContent = styled.div`
  padding: 18px;
  border-top: 1px solid #e7e7e7;
`

const Content = function ({ setShowContent, setOverlayVisible }) {
  const { currentNode, batchUpdateStageNode } = useBatchProcessStore((state) =>
    pick(state, ['currentNode', 'batchUpdateStageNode'])
  )
  const [showFields, setShowFields] = useState([])
  const {
    fields,
    selectedIds,
    tbId,
    setSelectedIds,
    fetchTbData,
    setIsShowBatchOperate,
    setRefreshStatus,
    tbData,
  } = useTbViewStore((state) =>
    pick(state, [
      'fields',
      'selectedIds',
      'tbId',
      'setSelectedIds',
      'fetchTbData',
      'setIsShowBatchOperate',
      'setRefreshStatus',
      'tbData',
    ])
  )
  const { setEditableSlugs, setEditableSlugFields } = useDetailStore((state) =>
    pick(state, ['setEditableSlugs', 'setEditableSlugFields'])
  )
  const ref = useRef()

  const { appId, tbs } = useAppEx((state) => pick(state, ['appId', 'tbs']))
  const { eventActionInfo } = currentNode
  const currentTbId = tbId

  // 本表单
  const updateUcaseAction = get(eventActionInfo, 'updateUcaseAction', {})
  // 外表单
  const editFormAction = get(eventActionInfo, 'editFormAction', {})
  // 本表单渲染的字段
  const current_children = get(
    updateUcaseAction && updateUcaseAction.fields,
    'children',
    []
  )
  // 外表单渲染的字段
  const other_children = get(
    editFormAction && editFormAction.fields,
    'children',
    []
  )

  // 当前表单要显示的tbDef
  let currentAllowedFields = null
  // 当前表单要显示的slug
  const currentSlugs = current_children.map((m) => m.slug)
  // 获取当前表单的tbDef
  if (currentSlugs) {
    currentAllowedFields = fields.filter((f) => currentSlugs.includes(f.slug))
  }

  // 其他表单要显示的tbDef
  let otherAllowedFields = null
  const otherTbId = editFormAction && editFormAction.tableTemplateId
  // 其他表单要显示的slug
  const otherSlugs = other_children.map((i) => i.slug)
  if (editFormAction) {
    const otherFields = tbs[otherTbId] ? tbs[otherTbId].fields : []
    otherAllowedFields = otherFields.filter((f) =>
      (otherSlugs || []).includes(f.slug)
    )
  }

  // 一共要显示的tbDef
  let allowedFields = Object.assign(
    [],
    otherAllowedFields,
    currentAllowedFields
  )
  allowedFields = allowedFields.map((field) => {
    return { ...field, hiddenWhenCreate: false }
  })

  // 以下位新修改

  const dealUcaseExtBackFill = async () => {
    if (current_children) {
      const arr = current_children.map((m) => m.slug)
      const firstSelectedData = tbData.find(
        (f) => f.objectId === selectedIds[selectedIds.length - 1]
      )
      const res = await fetchUcaseExtBackFill(
        appId,
        tbId,
        firstSelectedData.objectId,
        currentNode.stageId,
        currentNode.uuid
      )
      // 处理自动派发
      const editableSlugFields = current_children.map((item) => {
        const obj = (res && res[item.slug]) || {}
        const props = {}
        if (obj.selects) {
          props.selects = obj.selects
        }
        if (obj.defaultValue) {
          props.defaultValue = obj.defaultValue
        }

        const field = tbs[item.tbId]
          ? tbs[item.tbId].fields.find((f) => f.slug === item.slug)
          : null
        return {
          slug: item.slug,
          opts: {
            ...field,
            ...props,
          },
        }
      })
      setEditableSlugFields(editableSlugFields)
      setShowFields(
        allowedFields.map((m) => {
          const current = editableSlugFields.find((f) => f.slug === m.slug)
          const value = current ? current.opts : m
          value.hiddenWhenCreate = false
          return value
        })
      )
      setEditableSlugs(arr)
    }
  }
  useEffect(() => {
    dealUcaseExtBackFill()
  }, [eventActionInfo])

  // 以上为新修改

  useEffect(() => {}, [eventActionInfo])

  // 批量操作
  const batchFetchStageNode = () => {
    const obj = {
      createdData: {},
      updateData: {},
    }
    const values = ref.current ? ref.current.getValues() : {}
    // 其他表单内容
    if (otherTbId) {
      const otherMap =
        otherAllowedFields &&
        otherAllowedFields.map((f) => {
          return { [f.slug]: values[f.slug] }
        })
      const otherMapData = Object.assign({}, ...otherMap)
      obj.createdData[otherTbId] = otherMapData
    }
    // 当前表单内容
    if (currentAllowedFields && currentAllowedFields.length) {
      const currentMap =
        currentAllowedFields &&
        currentAllowedFields.map((f) => {
          return { [f.slug]: values[f.slug] }
        })
      const currentMapData = Object.assign({}, ...currentMap)
      obj.updateData[currentTbId] = currentMapData
    }
    setOverlayVisible(true)
    batchUpdateStageNode(obj, selectedIds)
      .then(() => {
        // 将选中数据清空
        setSelectedIds([])
        // 重新刷新表格数据
        fetchTbData()
        // 隐藏批量操作组件
        setIsShowBatchOperate(false)
        if (setRefreshStatus) {
          setRefreshStatus(true)
        }
        Toast.success({ title: `${selectedIds.length}条数据批量操作成功！` })
      })
      .finally(() => {
        setOverlayVisible(false)
      })
  }

  // 【提交】按钮点击事件
  const onClickSubmit = () => {
    // 批量操作
    if (ref && ref.current) {
      ref.current.trigger().then((tr) => {
        if (tr) {
          batchFetchStageNode()
        }
        return null
      })
    }
  }
  const fetchRemoteData = useFetchRemoteData()

  // 返回
  const goback = () => {
    setShowContent('node')
  }

  return (
    <StyledFormContent>
      {allowedFields && (
        <div>
          <WebBasicForm
            fields={showFields}
            onClickUpload={upload}
            ref={ref}
            onFetchRemoteData={fetchRemoteData}
          />
        </div>
      )}
      <StyledButtons>
        <Button type="primary" onClick={onClickSubmit}>
          提交
        </Button>
        <Button stroke onClick={goback}>
          返回
        </Button>
      </StyledButtons>
    </StyledFormContent>
  )
}
export default Content
